import { getAxiosInstance } from "../http";

import { MobileMoney } from "../models/mobile-money.model"

export class MobileMoneyServiceService {

    static getMobileMoneyServices = async (prefix?: string): Promise<MobileMoney[]> => {

        const instance = getAxiosInstance()

        const url = prefix ? prefix + '/services' : 'services'

        const response = await instance.get(url)

        const mm = response.data.map((s: any) => MobileMoney.fromJSON(s))

        return mm.sort((s1: MobileMoney, s2: MobileMoney) => s1.name?.localeCompare(s2.name!) )
    }


    static getMockMobileMoneyServices = (): MobileMoney[] => {
        const mockData = [
            { id: 1, name: 'Wave', bank: 'Wave', service_type: 'Mobile Money' },
            { id: 2, name: 'Orange Money', bank: 'Orange', service_type: 'Mobile Money' },
            { id: 3, name: 'Free Money', bank: 'Free', service_type: 'Mobile Money' },
            { id: 4, name: 'Western Union', bank: 'Western Union', service_type: 'Transfert International' },
            { id: 5, name: 'Money Gram', bank: 'MoneyGram', service_type: 'Transfert International' },
            { id: 6, name: 'Ria Money', bank: 'Ria', service_type: 'Transfert International' },
        ]
        return mockData.map(s => MobileMoney.fromJSON(s))
            .sort((s1, s2) => s1.name?.localeCompare(s2.name!) ?? 0)
    }

    static createService = async (service: MobileMoney, prefix?: string): Promise<MobileMoney> => {

        const instance = getAxiosInstance()

        const url = prefix ? prefix + '/services' : 'services'

        const payload = {name: service.name,  bank: service.bank, service_type: service.type}

        const response = await instance.post(url, JSON.stringify(payload))

        return MobileMoney.fromJSON(response.data)
    }

}
